<template>
  <div @click="sendClickEvent"
       :class="{'has-cursor-pointer':hasClickEvent, 'is-radius-bottom-right is-radius-bottom-left': isLast}"
       class="columns is-vcentered has-bg-light is-border-right is-border-bottom is-border-left">
    <div class="column is-padding-top-xsmall is-padding-bottom-xsmall" style="padding-left: 4px; padding-right: 4px; word-break: break-all;">
      <div class="truncate">
        <div class="is-size-6 has-text-grey">
          <span class="icon" v-if="hasClickEvent">
            <i v-if="isOpen" class="fal fa-chevron-down"></i>
            <i v-else class="fal fa-chevron-right"></i>
          </span>
          <span class="icon" v-else>&nbsp;</span>
          <span class="has-text-primary">{{event.created_on | dtFormat('DD/MM HH:mm')}}</span><abbr :title="event.title"> -&nbsp;{{event.title}}</abbr>
        </div>
      </div>
    </div>
    <div v-if="showIcon" class="column is-narrow is-padding-xsmall">
      <i class="has-text-grey is-size-5 fal fa-history"></i>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EventTracker',
    props: {
      event: {
        type: Object,
        required: true
      },
      isOpen: {
        type: Boolean,
        required: false,
        default: false
      },
      showIcon: {
        type: Boolean,
        required: false,
        default: false
      },
      hasClickEvent: {
        type: Boolean,
        required: false
      },
      isLast: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      faIcon () {
        const icons = {
          NEW: 'fal fa-plus-square',
          UPDATE: 'fal fa-file-edit',
          DELETE: 'fal fa-trash',
          EVENT: 'fal fa-info-circle'
        }
        if (this.event.flag in icons) {
          return icons[this.event.flag]
        } else {
          return 'fal fa-info-circle'
        }
      }
    },
    methods: {
      sendClickEvent () {
        if (!this.hasClickEvent) {
          return
        }
        this.$emit('onClick')
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/utils/EventTracker.vue